import { useEffect } from 'react';
import type { MainLoaderData } from '@/root';
import type { LinksFunction } from '@remix-run/node';
import onetrustConsentStyles from './onetrust-consent.css?url';

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: onetrustConsentStyles },
];

export const OneTrust = ({ env }: { env?: MainLoaderData['ENV'] }) => {
  useEffect(() => {
    (w => {
      w.OptanonWrapper = function OptanonWrapper() {};
    })(window);
  }, []);

  return (
    <>
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={env?.ONE_TRUST_SCRIPTS_ID}
      ></script>
    </>
  );
};
